<template>
    <app-content>
        <div class="card w-100 h-100">
            <diverse-input-group ref="inputGroup" :configs="inputConfigs"></diverse-input-group>
            <b-button @click="sendEmail" variant="warning" class="h-60px ml-2">send email</b-button>

            <b-input v-model="ids"></b-input>
            <b-button class="h-60px w-25 ml-2 mt-2">
                <a :href="downloadUrl()">test download material txt</a>
            </b-button>

            <div style="width: 500px">
                <faces-upload></faces-upload>
                <b-button @click="$refs.recognize.startRecognize()">open</b-button>
                <b-button class="ml-1" @click="$refs.recognize.closeVideo()">close</b-button>
                <face-recognize ref="recognize" style="height: 200px !important;"></face-recognize>
            </div>

            <em-attachment encrypted is-editing @idsChanged="testUpload"></em-attachment>
            <mini-multi-select :options="options"></mini-multi-select>
        </div>
        <b-button @click="$refs.abc.showModal()">123abc</b-button>
        <re-b-modal ref="abc" large max-height>
            <div class="d-flex flex-column h-100">
                <div class="bg-warning flex-shrink-0" style="height: 100px; resize: vertical;"></div>
                <div class="bg-success flex-grow-1 d-flex flex-column p-2 overflow-auto">
                    <div class="bg-white flex-shrink-0" style="height: 100px; resize: vertical;"></div>
                    <div class="bg-primary flex-grow-1 text-white d-flex overflow-auto p-2">
                        <div class="cl-grad-purple-blue w-100" style="flex: 0 0 auto; height: 1000px;">
                        </div>
                    </div>
                </div>
            </div>
        </re-b-modal>
    </app-content>
</template>

<script>
import AppContent from "@/components/echarts-part/stuff/AppContent";
import DiverseInputGroup from "@/components/workflow/stuffs/DiverseInputGroup";
import FacesUpload from "@/components/Face/FacesUpload.vue";
import FaceRecognize from "@/components/Face/FaceRecognize.vue";
import EmAttachment from "@/components/em/EmAttachment/index.vue";
import TableSearch from "@/components/common/inputs/table-search/TableSearch.vue";
import MiniMultiSelect from "@/components/workflow/stuffs/MiniMultiSelect.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";

export default {
    name: "TestPage",
    components: {
        ReBModal,
        MiniMultiSelect, TableSearch, EmAttachment, FaceRecognize, FacesUpload, DiverseInputGroup, AppContent
    },
    data() {
        return {
            inputConfigs: [
                {label: "To", name: "to", type: "input"},
                {label: "Cc", name: "cc", type: "input"},
                {label: "Subject", name: "subject", type: "input"},
                {label: "Content", name: "content", type: "input"},
            ],
            options: ['aasdf', 'sdfasb', 'casdfsfd'],
            ids: '1122786,1122785',

        }
    },
    computed: {
        svgSrc() {
            return require('../../../assets/images/project_info_background.svg');
        },
    },
    mounted() {
        this.$refs.abc.showModal();
    },
    methods: {
        tableDataChange(index, newVal) {
            console.log('index', index);
            console.log('newVal', newVal);
            // this.value[index] = newVal;
        },
        sendEmail() {
            let data = {};
            let temp = this.$refs.inputGroup.getInputData();
            if (temp.to) data.tos = [temp.to];
            if (temp.cc) data.ccs = [temp.cc];
            if (temp.subject) data.subject = temp.subject;
            if (temp.content) data.content = temp.content;

            this.$store.dispatch("api/post", {
                url: process.env.VUE_APP_SITHMES_PRD_URL + "/email/send",
                data: data
            });
        },

        downloadUrl() {
            return process.env.VUE_APP_SITHMES_MST_URL + "/sithMesMstMaterial/downloadTxt?materialIds=" + this.ids;
        },

        testUpload(ids) {
            console.log(ids)
        },
    }
}
</script>

<style scoped>

</style>
